import * as React from 'react';
import { createPortal } from 'react-dom';
import { classNames } from '@wix/answers-lib';
var ExpandedImage = function (_a) {
    var value = _a.value, isExpanded = _a.isExpanded, setExpandImgRef = _a.setExpandImgRef, hideFromDOM = _a.hideFromDOM, onDismiss = _a.onDismiss;
    var _b = React.useState(false), mounted = _b[0], setMounted = _b[1];
    React.useEffect(function () { return setMounted(true); }, []);
    return mounted && !value.link
        ? createPortal(React.createElement("div", { className: classNames('image-fullscreen-container', {
                expanded: isExpanded,
            }) },
            React.createElement("div", { tabIndex: -1, id: value.src, ref: setExpandImgRef, className: classNames('overlay', 'expanded-img', {
                    hide: hideFromDOM,
                }), onClick: onDismiss },
                React.createElement("img", { src: value.src, alt: value.alt || '' }))), document.body)
        : null;
};
export default ExpandedImage;
//# sourceMappingURL=expanded-image.js.map